/**
 * Hook partagé — stats de la base jurisprudentielle
 * Utilisé par PublicPricing, SettingsSubscription, PublicJurisprudence, PublicLegalGraph
 */

import { useState, useEffect } from 'react';

export interface DomaineDetail {
  domaine:   string;
  count_cc:  number;   // Cour de cassation
  count_ca:  number;   // Cours d'appel
  last_date: string | null;  // YYYY-MM-DD
}

export interface PublicStats {
  total:            number;
  domaines?:        [string, number][];
  domaines_detail?: DomaineDetail[];
  by_year?:         [string, number][];
  citations_total?: number;
  top_concepts?:    { concept: string; count: number }[];
}

export function useStats() {
  const [stats, setStats] = useState<PublicStats | null>(null);

  useEffect(() => {
    fetch('/api/fiches/stats')
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.total) setStats(data); })
      .catch(() => {});
  }, []);

  const totalStr = stats
    ? stats.total.toLocaleString('fr-FR')
    : null;

  const totalShort = stats
    ? `${(stats.total / 1_000_000).toFixed(1)}M+`
    : null;

  return { stats, totalStr, totalShort };
}